import Vue from 'vue'
Vue.filter('transDate', function (input) {
  if (typeof input == 'number') {
    var year = new Date(input).getFullYear(), month = new Date(input).getMonth() + 1, day = new Date(input).getDate()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    return year + '-' + month + '-' + day
  } else {
    return
  }
});
Vue.filter('transMonth', function (input) {
  if (typeof input == 'number') {
    var month = new Date(input).getMonth() + 1, day = new Date(input).getDate(),
    month = month < 10 ? '0' + month : month
    var day = day < 10 ? '0' + day : day
    var hour = new Date(input).getHours() < 10 ? '0' + new Date(input).getHours() : new Date(input).getHours()
    var min = new Date(input).getMinutes() < 10 ? '0' + new Date(input).getMinutes() : new Date(input).getMinutes()
    return month + '月' + day + '日' + hour + ':' + min
  } else {
    return
  }
});
Vue.filter('transHours', function (input) {
  if (typeof input == 'number' && input) {
    var Hours = new Date(input).getHours(), Minutes = new Date(input).getMinutes() ;
    Hours = Hours < 10 ? '0' + Hours : Hours
    Minutes = Minutes < 10 ? '0' + Minutes : Minutes
    return Hours + ':' + Minutes
  } else {
    return ''
  }
});
Vue.filter('mmdd', function (input) {
  if (typeof input == 'number') {
    let year = new Date(input).getFullYear(),
      month = new Date(input).getMonth() + 1,
      day = new Date(input).getDate();
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day

    if (year != new Date().getFullYear()) {
      return year + '-' + month + '-' + day
    } else {
      return month + '-' + day
    }

  } else {
    return ''
  }
});



// WEBPACK FOOTER //
// ./src/filters/index.js